import { createSlice } from "@reduxjs/toolkit";

export const permissionSlice = createSlice({
  name: "permission",
  initialState: {
    getPermissionResult: false,
    getPermissionLoading: false,
    getPermissionError: false,
    addPermissionResult: false,
    addPermissionLoading: false,
    deletePermissionResult: false,
  },
  reducers: {
    permissionReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_PERMISSION":
          return {
            ...state,
            getPermissionResult: payload.data,
            getPermissionLoading: payload.loading,
            getPermissionError: payload.error,
          };
        case "ADD_PERMISSION":
          return {
            ...state,
            addPermissionResult: payload.data,
            addPermissionLoading: payload.loading,
          };
        case "DELETE_PERMISSION":
          return {
            ...state,
            deletePermissionResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { permissionReducers } = permissionSlice.actions;

export default permissionSlice.reducer;
